import {Timestamp} from '@firebase/firestore';
import dayjs from "dayjs";

export function isFutureTimestamp(timestamp: Timestamp) {
  return dayjs(timestamp.toMillis()).isAfter(dayjs());
}


  /**
     * Formats seconds into HH:MM:SS string.
     * @param totalSeconds The total number of seconds.
     * @returns Formatted time string HH:MM:SS
     */
  export function formatSecondsToHMS(totalSeconds: number | undefined): string {
    if (totalSeconds === undefined || totalSeconds < 0) {
      return '00:00:00';
    }
    const hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = Math.floor(totalSeconds % 60);

    const pad = (num: number) => num.toString().padStart(2, '0');
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }


  /**
 * Converts a given value to a Date object.
 * Handles Firebase Timestamps, Date-compatible types, and null/undefined values.
 * @param dateValue The value to convert (Timestamp, string, number, or null/undefined).
 * @param defaultToCurrent If true and dateValue is null/undefined, returns the current Date.
 * Otherwise, returns undefined for null/undefined inputs.
 * @returns A Date object, or undefined if defaultToCurrent is false and dateValue is null/undefined.
 */
export function convertToDate(
  dateValue: Timestamp | string | number | null | undefined,
  defaultToCurrent: boolean = true
): Date | undefined {
  if (dateValue instanceof Timestamp) {
    return dateValue.toDate();
  }
  if (dateValue === null || dateValue === undefined) {
    return defaultToCurrent ? new Date() : undefined;
  }
  return new Date(dateValue);
}